module.exports = __webpack_public_path__ + "static/img/21280010.13acc646.png";